import { fromJS, Map } from 'immutable';
import { LOGOUT, LOGIN_ERROR, LOGIN_SUCCESS, SAVE_COMPANY_NAMES, SET_MFA_DATA, RESET_MFA, UPDATE_OTP_TOKEN } from '../constants/actions';

export function loginReducer(state: any = fromJS({ isMfaRequired: false }), action: any) {
    if (!Map.isMap(state)) {
        state = fromJS(state && typeof state === 'object' && !Array.isArray(state) ? state : { isMfaRequired: false });
    }
    switch (action.type) {
        case SAVE_COMPANY_NAMES:
            return state.set('companyNames', action.companyNames);
        case LOGIN_ERROR:
            return state.set('error', action.text);
        case SET_MFA_DATA:
            return state.set('isMfaRequired', true).set('mfaData', fromJS(action.mfaData));
        case RESET_MFA:
            return state.set('isMfaRequired', false).delete('mfaData');
        case UPDATE_OTP_TOKEN:
            return state.setIn(['mfaData', 'otp_token'], action.otpToken);
        case LOGIN_SUCCESS:
            return state.merge({
                'userId': action.userInfo.userId, 'firstName': action.userInfo.firstName,
                'userUID': action.userInfo.userUID, 'company': action.userInfo.company,
                'currentUserInfo': action.userInfo, 'isLoggedIn': true,
                'isMfaRequired': false
            }).delete('mfaData');
        case LOGOUT:
            return state.delete('userId').delete('firstName').delete('company')
                .delete('currentUserInfo').delete('mfaData').set('isLoggedIn', false).set('isMfaRequired', false);
        default:
            return state;
    }
}
